import React, { useEffect, useState } from "react";
import { Delete, Pen } from "lucide-react";
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { createProduct, deleteProduct, getProducts, updateProduct } from "../../../slices/company/rawProductSlice";
import { fetchRawCategories } from "../../../slices/company/rawCategorySlice";
import moment from "moment/moment";
import BillsProductForm from "./billsProduct";
import { createBill, deleteBill, fetchBills, updateBill } from "../../../slices/company/billsSlice";
import { fetchCustomers } from "../../../slices/company/customerSlice";
import { fetchFinalProducts } from "../../../slices/company/finalProductSlice";
import { customTableStyles } from "../../../utils/tableStylings";

const BillsProducts = () => {
    const dispatch = useDispatch();
    const [showModal, setShowModal] = useState(false); // To control modal visibility
    const [selectedProduct, setSelectedProduct] = useState([]);
    const [modalHeading, setModalHeading] = useState('');
    const { products } = useSelector(state => state.finalProduct);
    const { rawCategories } = useSelector(state => state.rawCategories);
    const { customers } = useSelector(state => state.customers);


    const { bills } = useSelector((state) => state.bills);


    useEffect(() => {
        const company = JSON.parse(localStorage.getItem('company'));
        if (company) {
            dispatch(fetchCustomers(company.company?.id));
            dispatch(fetchBills(company.company?.id));
        }
    }, [dispatch]);

    useEffect(() => {
        const company = JSON.parse(localStorage.getItem('company'));
        if (company) {
            const companyId = company.company?.id;
            dispatch(fetchRawCategories(companyId));
            dispatch(fetchFinalProducts(companyId));
        }
    }, [dispatch]);



    const handleFormSubmit = (formData) => {
        if (selectedProduct && selectedProduct.id != null) {
            dispatch(updateBill({ id: selectedProduct.id, updatedData: formData }));
        } else {
            const company = JSON.parse(localStorage.getItem('company'));

            const formDataObj = {
                ...formData,
                company_id: company.company?.id
            };
            dispatch(createBill(formDataObj));
        }
        setShowModal(false);

    };


    const handleEditTax = (productData) => {
        setSelectedProduct(productData);
        setModalHeading('Edit Bill') // Pass the supplier data to edit
        setShowModal(true);
    };

    const handleDelete = (taxId) => {
        Swal.fire({
            title: '<strong>Are you sure?</strong>',
            html: `<p>This action will <b>permanently delete</b> this Bill.</p>`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel',
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(deleteBill(taxId));
                Swal.fire({
                    icon: 'success',
                    title: 'Deleted!',
                    text: 'The Bill has been deleted.',
                    toast: true,          // Enable toast style
                    position: 'top-end',  // Position at the top-right corner
                    showConfirmButton: false,  // Hide the confirm button
                    timer: 3000,          // Set the timer to auto-close after 3 seconds
                    timerProgressBar: true,  // Show the progress bar for the timer
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer);
                        toast.addEventListener('mouseleave', Swal.resumeTimer);
                    }
                });

            }
        });

    };


    const productsColumn = [
        {
            name: '#',
            cell: (row, index) => index + 1, // Show index of the row
            width: '50px'
        },
        {
            name: 'Company Name',
            selector: row => row.Customer?.company_name,
            sortable: true
        },
        {
            name: 'Customer Name',
            selector: row => row.Customer?.name,
            sortable: true
        },
        {
            name: 'Bill Number',
            selector: row => row.bill_number,
            sortable: true
        },
        {
            name: 'Bill Date',
            selector: row => moment(row.bill_date).format('DD MMMM, YYYY'),
            sortable: true
        },
        {
            name: 'Receiving Date',
            selector: row => moment(row.due_date).format('DD MMMM, YYYY'),
            sortable: true
        },
        {
            name: 'Order Number',
            selector: row => row.order_number,
            sortable: true
        },
        {
            name: 'Actions',
            cell: row => (
                <>
                    <span
                        className="text-warning cursor-pointer me-2"
                        onClick={() => handleEditTax(row)}
                    >
                        <Pen />
                    </span>
                    <span
                        className="text-danger cursor-pointer"
                        onClick={() => handleDelete(row.id)}
                    >
                        <Delete />
                    </span>
                </>
            ),
            width: '150px'
        }
    ];

    const handleAdd = () => {
        setSelectedProduct([]);
        setModalHeading('Create New Bill');// No supplier means we are adding a new one
        setShowModal(true);
    };



    return (
        <>
            <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center mb-3">
                    <h2>Bills </h2>
                    <button
                        className="btn btn-primary"
                        onClick={() => handleAdd()}
                    >
                        + Add New
                    </button>
                </div>
                <div className="card-body">
                    <DataTable
                        columns={productsColumn}
                        data={bills}
                        pagination
                        highlightOnHover
                        striped
                        dense
                        customStyles={customTableStyles}
                    />
                </div>
            </div>
            <BillsProductForm show={showModal} onClose={() => setShowModal(false)} heading={modalHeading} initialData={selectedProduct} onSubmit={handleFormSubmit} categories={rawCategories} customers={customers} products={products} />
        </>
    );
}

export default BillsProducts;